export default "__VITE_ASSET__133ff657__"